export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2">关于吃瓜网站</h2>
        <p className="text-sm text-foreground-500 mb-8">了解我们的故事与使命</p>
        <div className="bg-background-100 rounded-xl border border-background-200/70 p-6 md:p-8">
          <div className="prose prose-sm max-w-none">
            <h3 className="text-base font-semibold text-foreground-900 mb-3">我们是谁</h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              吃瓜网站成立于2024年，是国内领先的网红明星精品爆料平台。我们致力于为广大吃瓜爱好者提供最及时、最全面的网红吃瓜吃料网每日爆料服务。
            </p>
            <h3 className="text-base font-semibold text-foreground-900 mb-3">我们的使命</h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              打造全网最值得信赖的国产51精品入口吃瓜爆料平台。从顶流明星到新人网红，从综艺内幕到直播翻车，我们用专业的眼光和严谨的态度，为每一位吃瓜人呈现最真实、最有料的网红最新爆料。
            </p>
            <h3 className="text-base font-semibold text-foreground-900 mb-3">内容准则</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              我们坚持吃瓜爆料每日更新，所有精品吃瓜内幕均经过编辑团队审核。我们拒绝恶意造谣和人身攻击，在传递娱乐信息的同时，也尊重每一位公众人物的合法权益。
            </p>
          </div>
          <div className="flex flex-wrap gap-4 mt-6 pt-5 border-t border-background-200/60">
            <div className="flex items-center gap-2">
              <span className="text-2xl font-heading text-primary-600">500+</span>
              <span className="text-xs text-foreground-500">日均爆料</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-2xl font-heading text-primary-600">200万+</span>
              <span className="text-xs text-foreground-500">月活瓜友</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-2xl font-heading text-primary-600">365天</span>
              <span className="text-xs text-foreground-500">全年无休</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}